export const removeEmbedPrefix = (str) => {
    const prefix = '/embed';
    if (str.startsWith(prefix)) {
      return str.slice(prefix.length);
    }


    
    return str;
  }